import { loginMsg } from '@/hooks/pages/login/useLogin';

export const LoginMessage = () => {
  return loginMsg === '' ? null : <p className="login__error">{loginMsg}</p>;
};
